module.exports = __webpack_public_path__ + "static/img/payment_detail.c5c1d88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/payment_detail.png
// module id = HLmI
// module chunks = 8